class AMaterialRow {
	constructor(element) {
		const aElement = element.querySelector('a');
		element.classList.add('-js');

		element.addEventListener('click', () => {
			window.location.href = aElement.href;
		});
	}
}

export default AMaterialRow;

[...document.querySelectorAll('.a-material-row')].forEach((element) => new AMaterialRow(element));
